import Vue from 'vue'
import Vuex from 'vuex'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    home: false,
    about: false,
    privacy: false,
    activitiesList: false,
    activities: {},
    activityGroups: {},
    eventsList: false,
    events: {},
    artworksList: false,
    artworks: {},
    resources: {},
    people: {},
    tags: {},
    showIntro: true,
    isMobile: false,
    menuOpen: false
  },
  actions,
  mutations
})
